<div class="view">
  <app-header *ngIf="router.url!='/' && 
!router.url.includes('/recurring')
">
  </app-header>
  <router-outlet></router-outlet>
</div>